import { render, staticRenderFns } from "./store-items-list.vue?vue&type=template&id=ab066310&scoped=true"
import script from "./store-items-list.vue?vue&type=script&lang=js"
export * from "./store-items-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab066310",
  null
  
)

export default component.exports